import { render, staticRenderFns } from "./integralsetting.vue?vue&type=template&id=40c090ca&scoped=true&"
import script from "./integralsetting.vue?vue&type=script&lang=js&"
export * from "./integralsetting.vue?vue&type=script&lang=js&"
import style0 from "./integralsetting.vue?vue&type=style&index=0&id=40c090ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c090ca",
  null
  
)

export default component.exports